import { render, staticRenderFns } from "./ProjectElegantPage.vue?vue&type=template&id=7add53e4&scoped=true&"
import script from "./ProjectElegantPage.vue?vue&type=script&lang=js&"
export * from "./ProjectElegantPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectElegantPage.vue?vue&type=style&index=0&id=7add53e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add53e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
